import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { flattenFields } from './flatten-fields.js'

export function getManyToManyFields(fields: SchemaField[]): SchemaField[] {
  const flat = flattenFields(fields)
  return flat.filter((f) => f.type === 'relationship' && f.multiple === true && f.relationship)
}
